import {premises} from './premises';
import {cabinets} from './cabinets';
import * as _ from 'underscore';

export function data(state, action) {
    return Object.assign({}, state, {
        premises: premises(state.premises, action),
        units: cabinets(state.units, action),
        sensors: readings(state.sensors, action)
    });
}

export const READINGS_UPDATE = 'UPDATE_SENSOR_READINGS';
export const READINGS_UPDATE_LATEST = 'UPDATE_LATEST_SENSOR_READINGS';
export function readings(state, action) {
    let toMerge = {};
    if (action.type == READINGS_UPDATE) {
        if (!(action.reset)){
            if (action.data.error) {
                toMerge[action.unit] = {error: action.data.error};
            } else if (action.unit){
                let currentReadings = state[action.unit] && state[action.unit].readings;
                if (currentReadings) {
                    let minTimestamp = action.data.count > 0 ?
                        (action.data.objects[0].timestamp - (4 * 60 * 60)) : 0;
                    let idx = _.indexOf(currentReadings, r => r.timestamp >= minTimestamp);
                    if (idx > 0) {
                        currentReadings = _.rest(currentReadings, idx - 1);
                    }
                }else {
                    currentReadings = [];
                }
                let newReadings = currentReadings.concat(action.data.count > 0 ? action.data.objects.reverse() : []);
                toMerge[action.unit] = {
                    count: newReadings.length,
                    readings: newReadings
                };
            }
        }else {
            state = {}
        }
        return Object.assign({}, state, toMerge);
    } else if(action.type == READINGS_UPDATE_LATEST) {
        return Object.assign({}, state, action.data);
    }
    return state;
}
